// extracted by mini-css-extract-plugin
export default {"cls1":"PWMvBUCmBfVFMTlnNq2G","cls2":"MQ8Rh5P2DFix3PmDkjmc PWMvBUCmBfVFMTlnNq2G"};